import '@/styles/global.css';

import { SPALayout } from '@crehana/layouts/spa/layout-with-centralized';
import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react';

import { AddBaseFunctionality } from '@/shared/components/add-base-functionality';
import ReactQueryProvider from '@/shared/components/react-query-provider';
import { Outlet, useParams } from '@/shared/modern-router';

// import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';

const App = () => {
  const { slug } = useParams();
  // const { pathname } = useLocation();

  // Determine the view mode based on the current URL.
  // const currentViewMode = /^\/panel\/admin(\/|$)/.test(pathname)
  // ? 'admin'
  // : 'end-user';

  return (
    <div className="tw-isolate">
      <SPALayout sentryInstance={Sentry} organizationSlug={slug as string}>
        <NuqsAdapter>
          <ReactQueryProvider>
            <Outlet />
            {/* TODO: Re-enable HanaFloatingChat once the configurations feature is implemented */}
            {/* <HanaFloatingChatLazy currentViewMode={currentViewMode} /> */}
          </ReactQueryProvider>
        </NuqsAdapter>
        <AddBaseFunctionality />
      </SPALayout>
    </div>
  );
};

export default App;
